// extracted by mini-css-extract-plugin
module.exports = {"OrgInviteMemberListBase":"OrgInviteMemberList_OrgInviteMemberListBase__y6vDG","OrgInviteMemberListWrap":"OrgInviteMemberList_OrgInviteMemberListWrap__2lerP"};